/* eslint-disable react-hooks/exhaustive-deps */
//Context to handle Collaborators
import axios from "axios";
import { createContext, useContext, useEffect, useState } from "react";
import { useStrapiAuthContext } from "./StrapiV3AuthContext";

export const CollaboratorsContext = createContext({});

export function CollaboratorsProvider({ children }) {
  const [collaborators, setCollaborators] = useState([]);

  const { token } = useStrapiAuthContext();

  //function to get all collaborators
  const getAllCollaborators = async () => {
    return await axios.get(
      `${process.env.REACT_APP_URL_API}/colaboradores?_sort=Nombre:ASC&_limit=-1`,
      {
        headers: { Authorization: `Bearer ${token}` },
      }
    );
  };

  //function to filter collaborators by project
  const filterCollaboratorsByProject = (project) => {
    getAllCollaborators().then(function (response) {
      if (project) {
        setCollaborators(
          response.data.filter((collaborator) => {
            return collaborator.Proyectos === project && collaborator;
          })
        );
      } else {
        setCollaborators(response.data);
      }
    });
  };

  //UseEffect to get collaborators from API
  useEffect(() => {
    if (token) {
      getAllCollaborators().then(function (response) {
        setCollaborators(response.data);
      });
    }
  }, [token]);
  return (
    <CollaboratorsContext.Provider
      value={{ collaborators, filterCollaboratorsByProject }}
    >
      {children}
    </CollaboratorsContext.Provider>
  );
}

export const useCollaboratorsContext = () => {
  return useContext(CollaboratorsContext);
};
